import type { Enums, Nullable } from "../types";

export function getAttendanceWorksiteColor(
	type: Nullable<Enums<"attendanceWorksiteType">>,
): Enums<"color"> {
	switch (type) {
		case "home-office":
			return "blue";
		case "office":
			return "green";
		case "project-site":
			return "orange";
		case "warehouse":
			return "purple";
		case "commute":
			return "teal";
		default:
			return "gray";
	}
}
